// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit'
import cartReducer from './cartSlice'
import authReducer from './authSlice'
import navigationReducer from './navigationSlice'
import checkouteReducer from './checkoutSlice'
import wishlistReducer from './wishlistSlice'

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    auth: authReducer, // 👈 nuevo
    navigation: navigationReducer,
    checkout: checkouteReducer,
    wishlist: wishlistReducer
  }
})
